<template>
  <v-container class="py-0">
    <v-row>
      <v-col cols="12">
        <v-textarea
          v-model="search"
          rows="1"
          auto-grow
          @keyup="handleKeyUpSearch"
          @click:clear="handleClickClearSearch"
          light
          label="Search users"
          solo-inverted
          clearable
          dense
          class="search-box"
          prepend-inner-icon="fas fa-search"
        ></v-textarea>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-list two-line class="py-0 user-list">
          <v-list-item-group>
            <template>
              <div v-if="!isAllUsers && !users.length" class="pa-2">
                No users in group
              </div>
              <div v-if="isAllUsers && !users.length" class="pa-2">
                No available users
              </div>
              <div v-for="(user, index) in users" :key="index">
                <v-list-item :title="getUserTitle(user)">
                  <template>
                    <v-list-item-avatar size="36">
                      <v-img :src="user.picture"></v-img>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title
                        >{{ user.firstName }}
                        {{ user.lastName }}</v-list-item-title
                      >
                      <v-list-item-subtitle>{{
                        user.email
                      }}</v-list-item-subtitle>
                    </v-list-item-content>

                    <v-btn
                      v-if="!user.inGroup"
                      color="primary"
                      x-small
                      elevation="0"
                      @click="handleAddToGroup(user)"
                      >Add to group</v-btn
                    >
                    <v-btn
                      v-if="user.inGroup"
                      x-small
                      elevation="0"
                      @click="handleRemoveFromGroup(user)"
                      >Remove from group</v-btn
                    >
                  </template>
                </v-list-item>

                <v-divider
                  v-if="index < users.length - 1"
                  :key="index"
                ></v-divider>
              </div>
            </template>
          </v-list-item-group>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import lodashFind from "lodash/find";
import lodashOrderBy from "lodash/orderBy";
import lodashSortedUniq from "lodash/sortedUniq";

import { mapGetters } from "vuex";
import { MODULE_PREFIX_USER } from "@/store";
import { GET_GROUP_MEMBERS } from "@/store/actions.type";

const EMITTED_ACTIONS = {
  ADD: "add",
  REMOVE: "remove",
};

export default {
  name: "CommsUserList",
  components: {},
  props: {
    type: {
      type: String,
      validator: (value) => {
        return ["users_group", "users_all"].indexOf(value) !== -1;
      },
    },
    groupUsers: {
      type: Array,
    },
  },
  data: () => ({
    users: [],
    search: null,
  }),
  computed: {
    ...mapGetters({
      groupMembers: MODULE_PREFIX_USER + "groupMembers",
    }),
    isAllUsers() {
      return this.type === "users_all";
    },
  },
  async mounted() {
    await this.$store.dispatch(MODULE_PREFIX_USER + GET_GROUP_MEMBERS);
    await this.loadUsers();
  },
  methods: {
    async loadUsers() {
      if (this.groupMembers.length <= 0) {
        return;
      }
      let mapped = [];
      this.groupMembers.forEach((member) => {
        let isInGroup = false;
        if (this.groupUsers) {
          isInGroup = !!lodashFind(this.groupUsers, ["id", member.id]);
        }
        if (this.isAllUsers || isInGroup) {
          if (!this.search || (this.search && this.isInSearch(member))) {
            mapped.push({
              id: member.id,
              email: member.email.toLowerCase(),
              firstName: member.firstName ? member.firstName : "",
              lastName: member.lastName ? member.lastName : "",
              picture: member.picture,
              inGroup: isInGroup,
            });
          }
        }
      });
      const SORTED = lodashOrderBy(mapped, ["lastName", "firstName", "email"]);
      const SORTED_UNIQUE = lodashSortedUniq(SORTED, "email");
      this.users = SORTED_UNIQUE;
    },
    isInSearch(user) {
      return (
        (user.firstName &&
          user.firstName.toLowerCase().indexOf(this.search.toLowerCase()) >
            -1) ||
        (user.lastName &&
          user.lastName.toLowerCase().indexOf(this.search.toLowerCase()) >
            -1) ||
        (user.email &&
          user.email.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
      );
    },
    getUserTitle(user) {
      const firstName = user.firstName ? user.firstName : "";
      const lastName = user.lastName ? user.lastName : "";
      return `${firstName} ${lastName} ${user.email}`;
    },
    handleAddToGroup(user) {
      user.inGroup = true;
      this.$emit(EMITTED_ACTIONS.ADD, user);
    },
    handleRemoveFromGroup(user) {
      user.inGroup = false;
      this.$emit(EMITTED_ACTIONS.REMOVE, user);
    },
    handleKeyUpSearch() {
      this.loadUsers();
    },
    handleClickClearSearch() {
      this.search = null;
      this.loadUsers();
    },
  },
  watch: {
    type: {
      handler(newVal, oldVal) {
        this.search = null;
        this.loadUsers();
      },
    },
    groupUsers: {
      handler() {
        if (this.groupUsers) {
          this.loadUsers();
        }
      },
      deep: true,
    },
  },
};
</script>

<style>
.search-box {
  font-size: 14px;
}
.search-box .v-icon {
  font-size: 14px !important;
}
.search-box.v-text-field.v-text-field--enclosed .v-text-field__details {
  display: none;
}
.search-box.theme--light.v-text-field--solo-inverted.v-input--is-focused
  > .v-input__control
  > .v-input__slot {
  background-color: rgba(0, 0, 0, 0.06);
}
.search-box.theme--light.v-text-field--solo-inverted.v-input--is-focused
  > .v-input__control
  > .v-input__slot
  input {
  color: rgba(0, 0, 0, 0.6);
}
.search-box.theme--light.v-text-field--solo-inverted.v-input--is-focused
  > .v-input__control
  > .v-input__slot
  .v-label {
  color: rgba(0, 0, 0, 0.6);
}
.bounds-radio-text .v-input--selection-controls .v-input__slot > .v-label,
.v-input--selection-controls .v-radio > .v-label {
  font-size: 12px;
}
.search-box * .v-input__slot {
  padding-left: 4px !important;
  padding-right: 4px !important;
}
</style>

<style scoped>
.user-list {
  height: 65vh;
  overflow-y: auto;
}
</style>
